export const MEMBER_REWARD_STATUSES = {
    AWARDED: 'Awarded',
    ELIGIBLE: 'Eligible',
    LOCKED: 'Locked',
    REDEEMED: 'Redeemed',
} as const;

export type MemberRewardStatus = (typeof MEMBER_REWARD_STATUSES)[keyof typeof MEMBER_REWARD_STATUSES];
